import * as FormFields from "components/formfields";
import { LoginValidation } from "utils/Validation";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import { login } from "services/auth.service";

const LoginForm = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await login({
        email: values.email,
        password: values.password,
      });
      localStorage.setItem("token", res.data.token);
      toast.success(`Welcome ${res.data.fullName}`);
      navigate("/");
    } catch (error) {
      toast.error(error?.error || "Error logging in. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={LoginValidation}
      onSubmit={handleSubmit}>
      {({ isSubmitting, isValid }) => {
        return (
          <Form className="mt-8 mb-7">
            <div className="mb-4">
              <FormFields.InputField
                name="email"
                label="Email"
                type="email"
                placeholder="Enter Email"
                size="large"
              />
            </div>
            <div className="mb-4">
              <FormFields.PasswordField
                name="password"
                label="Password"
                type="password"
                placeholder="Password"
                size="large"
              />
            </div>

            <FormFields.AuthButton
              type="submit"
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              submitingText={"Logging in..."}>
              Login
            </FormFields.AuthButton>
          </Form>
        );
      }}
    </Formik>
  );
};

export default LoginForm;
